export default "__VITE_ASSET__BLBDqEZK__"